var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useState } from 'react';
import { apiGetListProfessionalAd } from '@/actions/ProfessionalAdActions';
import { usePageViewAction } from '@/hooks/action/pageView/usePageViewAction';
import { usePromiseDoingCallback } from '@/hooks/async/loading/usePromiseDoingCallback';
import { wrapDispatch } from '@/utils/actions/dispatch';
/**
 * コンサルホットライン（コンサル側）バナー表示に関連するカスタムフック
 */
export const useMyPageBanner = (options) => {
    const { dispatch, onError, onSuccess, unmountRef } = options;
    const [list, setList] = useState(null);
    // バナークリック計測用の処理取得
    const { createUserPageView: onClickBannerBase } = usePageViewAction({
        action: 'professional_ad',
        subAction: 'mypage_side_banner',
    });
    // バナー計測用の処理取得
    const { createUserPageView: onDisplayBannerBase } = usePageViewAction({
        action: 'professional_ad',
        subAction: 'mypage_side_banner_impression',
    });
    /**
     * データ取得
     */
    const fetchListBase = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const { payload } = yield wrapDispatch(dispatch, apiGetListProfessionalAd({}, {}));
            if (!unmountRef.current) {
                setList(payload.list);
                yield (onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess());
            }
        }
        catch (e) {
            if (!unmountRef.current) {
                return;
            }
            yield (onError === null || onError === void 0 ? void 0 : onError(e));
            throw e;
        }
    }), [dispatch, onError, onSuccess, setList, unmountRef]);
    // ローディング制御
    const { callbackPromiseEvent: fetchList, doing: isLoading } = usePromiseDoingCallback({
        initialDoingState: true,
        promiseEvent: fetchListBase,
        unmountRef,
    });
    /**
     * バナー用の処理
     */
    const onClickBanner = useCallback((id) => () => {
        onClickBannerBase(id);
    }, [onClickBannerBase]);
    /**
     * バナー表示時の処理
     */
    const onDisplayBanner = useCallback((id) => () => {
        onDisplayBannerBase(id);
    }, [onDisplayBannerBase]);
    return {
        fetchList,
        isLoading,
        list,
        onClickBanner,
        onDisplayBanner,
    };
};
